import {AdacRoutes} from '@/routes/adac'
import {LimangoRoutes} from '@/routes/limango'
import {OoesbRoutes} from '@/routes/ooesb'
import {PiratInViaggioRoutes} from '@/routes/piratinviaggio'
import {WatItalyRoutes} from '@/routes/watitaly'
import {UrlaubsguruRoutes} from '@/routes/urlaubsguru'
import {SbscomRoutes} from '@/routes/sbscom'
import {DefaultRoutes} from '@/routes/default'

const config = require(process.env.CONFIG_LOCATION)
let shop = config.whitelabelConfig.short.toLowerCase()

const getAdditionalRoutes = () => {
  switch (shop) {
    case 'adac':
      return AdacRoutes
    case 'limango':
      return LimangoRoutes
    case 'ooesb':
      return OoesbRoutes
    case 'piratinviaggio':
      return PiratInViaggioRoutes
    case 'watitaly':
      return WatItalyRoutes
    case 'urlaubsguru':
      return UrlaubsguruRoutes
    case 'sbscom':
      return SbscomRoutes
    default:
      return DefaultRoutes
  }
}

export default {
  getAdditionalRoutes,
}
